import { AddIcon, Image, TagIcon, TrashIcon } from '@iheartjane/reefer';
import { clsx } from 'clsx';
import { useFetcher } from 'react-router';

import { CartAction } from '@jane/bloom/types/actions/cart';

import styles from './bundleCard.module.css';

type BundleCardProps = {
  active?: boolean;
  dealUnlocked?: boolean;
  hasDependent?: boolean;
  img?: string[];
  priceId?: string;
  productId?: number;
  productName?: string;
};

export const BundleCard = ({
  active,
  dealUnlocked,
  hasDependent,
  img,
  priceId,
  productId,
  productName,
}: BundleCardProps) => {
  const fetcher = useFetcher();

  const handleDelete = () => {
    fetcher.submit(
      {
        intent: CartAction.DeleteItem,
        priceId: priceId ?? null,
        productId: productId?.toString() ?? null,
      },
      {
        action: `/api/cart-items`,
        method: 'POST',
      }
    );
  };

  return (
    <div
      className={clsx(styles['bundleCard'], {
        [styles['activeCard']]: active,
        [styles['dealUnlocked']]: active && dealUnlocked,
      })}
    >
      {img && (
        <>
          <button
            type="button"
            className={styles['trashBundle']}
            onClick={handleDelete}
            disabled={fetcher.state === 'submitting'}
          >
            <TrashIcon size="md" />
          </button>

          <div className={styles['bundleCardImage']}>
            <Image
              src={img[0]}
              altText={productName || ''}
              border
              loading="eager"
              objectFit="contain"
              borderRadius="16px"
            />
          </div>
        </>
      )}

      {!img &&
        (hasDependent ? (
          <TagIcon size="lg" color="inherit" />
        ) : (
          <AddIcon size="lg" color="inherit" />
        ))}
    </div>
  );
};
